import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../css/Navbar.css";

function CollapsibleExample() {
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className="bg-body-tertiary"
      bg="dark"
      data-bs-theme="dark"
      id="usgsbanner"
    >
      <div>
        <Navbar.Brand
          href="https://www.usgs.gov/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="img/usgs_logo.png"
            className="d-inline-block align-center me-2
            "
            alt="USGS - science for a changing world"
            title="U.S. Geological Survey Home Page"
            style={{ maxHeight: "48px" }} // Use inline styles to control max height
          />
        </Navbar.Brand>
        <Navbar.Brand
          href="https://nationalmap.gov/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="img/tnm_logo_large.png"
            className="d-inline-block align-center"
            alt="The National Map"
            title="The National Map"
            style={{ maxHeight: "32px" }} // Use inline styles to control max height
          />
        </Navbar.Brand>
      </div>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse
        id="responsive-navbar-nav"
        className="justify-content-end text-end"
      >
        <Nav>
          <Nav.Link
            href="https://www.usgs.gov/"
            target="_blank"
            rel="noreferrer"
          >
            USGS Home
          </Nav.Link>
          <Nav.Link
            href="https://answers.usgs.gov/"
            target="_blank"
            rel="noreferrer"
          >
            Contact USGS
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default CollapsibleExample;
